import { render, staticRenderFns } from "./SliderBullets.vue?vue&type=template&id=f2adc0fc&scoped=true&"
import script from "./SliderBullets.vue?vue&type=script&lang=ts&"
export * from "./SliderBullets.vue?vue&type=script&lang=ts&"
import style0 from "./SliderBullets.vue?vue&type=style&index=0&id=f2adc0fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2adc0fc",
  null
  
)

export default component.exports